import React, { Component } from 'react';
import axios from "axios";

import api from '../../../../api/';
import ParadigmaTable from "../../../../components/ParadigmaTable/";
import AdjuntarModal from './AdjuntarModal.js';

class Listas extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "Código",
                    id: "Codigo",
                    accessor: "Codigo",
                    show: true,
                    width:150,
                },
                {
                    Header: "Nombre",
                    id: "Nombre",
                    accessor: d => d.Nombre,
                    show: true,
                },
                {
                    Header: "Incluye IVA",
                    id: "IncluyeIVA",
                    accessor: d => d.IncluyeIVA ? "SI" : "NO",
                    show: true,
                    filterable: true,
                    lookup:"exact",
                    Filter: ({ filter, onChange }) =>(
                         <select
                         onChange={event => onChange(event.target.value)}
                         style={{ width: "100%" }}
                         value={filter ? filter.value : "TODOS"}>
                         <option value="">TODOS</option>
                         <option value={"True"}>SI</option>
                         <option value={"False"}>NO</option>
                         </select>
                    ),
                    width: 100,
                    className:"text-center",
                },
                {
                    Header: "Fichero",
                    id: "Fichero",
                    accessor: "Fichero",
                    Cell:d => d.original.Fichero ? (<a target="_blank" href={d.original.Fichero} title="Descargar"><i class="fa fa-share" aria-hidden="true"></i></a>) : null,
                    className:"text-center",
                    show: true,
                    width:100,
                },
                {
                    Header: "De Baja",
                    id: "DeBaja",
                    accessor: d => d.DeBaja ? "SI" : "NO",
                    show: true,
                    filterable: true,
                    lookup:"exact",
                    Filter: ({ filter, onChange }) =>(
                         <select
                         onChange={event => onChange(event.target.value)}
                         style={{ width: "100%" }}
                         value={filter ? filter.value : ""}>
                         <option value="">TODOS</option>
                         <option value={"True"}>SI</option>
                         <option value={"False"}>NO</option>
                         </select>
                    ),
                    width: 100,
                    className:"text-center",
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        const { modernTheme } = this.props;
        return (
            <ParadigmaTable
                modernTheme={modernTheme}
                buttons={[
                     {
                         edit: true,
                         component: (props) => <AdjuntarModal {...props} action="EDIT" />,
                         permission:"ecommerce_precios_listasdeprecios_adjunto",
                     },
                     {
                         edit: true,
                         component: (props) => <AdjuntarModal {...props} action="DELETE" />,
                         permission:"ecommerce_precios_listasdeprecios_adjunto",
                     },
                ]}
                outerFilter={[{id:"DeBaja", lookup:"exact", value:"False"}]}
                apiUrl={api.gestion.precios.listas}
                columns={this.state.columns}
                title={"Listas de Precios"}
            />
        );
    }
}

export default Listas;



// WEBPACK FOOTER //
// ./src/views/Gestion/Precios/Listas/Listas.js